import { authInstance } from "./baseInstance";
export const logoutAPI = (token) => {
  return authInstance.post("/auth/sign-out");
};
